(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ImageCompare", [], factory);
	else if(typeof exports === 'object')
		exports["ImageCompare"] = factory();
	else
		root["ImageCompare"] = factory();
})(window, function() {
return 